import VodItem from "./VodItem";

export default VodItem;
